import { useClient, useClients } from '@entities/clients';
import { useClientIdsSelect, useSelectedClient } from '@entities/clients/heplers.ts';
import cn from 'classnames';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useClientMobilePageRedirect } from '@pages/clients/client-page/useClientMobilePageRedirect.ts';
import { SelectingIdsIconCheckbox } from '@widgets/shared/SelectingIconCheckbox/index.ts';
import { ModerationCircle } from '@shared/assets';
import { useWindowWidth } from '@shared/hooks';
import type { Client } from '@shared/types/users';
import { Avatar } from '@shared/ui/avatar';
import { IconCheckbox } from '@shared/ui/inputs/iconCheckbox/index.ts';
import * as st from './styles.module.scss';

interface OldProps {
  id: number;
}

export const Card: React.FC<OldProps> = ({ id }) => {
  const { idGroup } = useParams();
  const { select, selectedClient, isClientSelected, isSelectionOn, selectForList } = useClients();
  const { client } = useClient(id);

  const getClientName = (client?: Client) => {
    if (!client) return;
    let output = '';
    client?.last_name && (output += client.last_name);
    client?.first_name && (output += ` ${client.first_name}`);
    return output;
  };

  const navigate = useNavigate();
  const isMobile = useWindowWidth() <= 768;

  const onSelect = () => select(id);

  const ids: number[] = [];

  client &&
    client.user.custom_groups &&
    client.user.custom_groups.length > 0 &&
    client.user.custom_groups.map((group) => ids.push(group.id));

  useEffect(() => {
    if (
      isSelectionOn &&
      client &&
      idGroup &&
      !isClientSelected(id) &&
      ids.includes(Number(idGroup))
    ) {
      selectForList(id, !isClientSelected(id));
    }
  }, [idGroup]);

  return (
    <li
      className={cn(st.item, selectedClient === id && !isMobile && st.active)}
      onClick={() => {
        if (isMobile)
          return !isSelectionOn && navigate(`${id}`, { state: { path: window.location.pathname } });
        if (!isMobile) return onSelect();
      }}
      id={`${id}`}
    >
      <div
        className={st.item__color}
        style={{
          display: selectedClient !== id || isMobile ? 'flex' : 'none',
          backgroundColor: `${client?.color_tag}`,
        }}
      />
      {isSelectionOn && (
        <IconCheckbox
          className={st.item__body}
          checked={isClientSelected(id)}
          onClick={(e) => {
            e.stopPropagation();
            selectForList(id, !isClientSelected(id));
          }}
        />
      )}
      <Avatar src={client?.photo} />

      <div className={cn(st.item__name)} onClick={onSelect}>
        {getClientName(client)}
      </div>
      <div className={st.item__right}>
        <div className={st.item__moderationIcon}>
          {!client?.is_registered && <ModerationCircle />}
        </div>
      </div>
    </li>
  );
};

type ClientCardSmallPT = {
  client: Client;
  onClick?: () => void;
};

export const ClientCardSmall = ({ client, onClick }: ClientCardSmallPT) => {
  // const { idGroup } = useParams();
  // const { select, selectedClient, isClientSelected, isSelectionOn, selectForList } = useClients();
  // const { client } = useClient(id);
  const { doRedirectWithSavePageUrl } = useClientMobilePageRedirect();
  const { selectedClient, setSelectedClient } = useSelectedClient();

  const { doAddId, isSelecting, isIdSelected, doToggleId } = useClientIdsSelect();

  const getClientName = (client?: Client) => {
    if (!client) return;
    let output = '';
    client?.last_name && (output += client.last_name);
    client?.first_name && (output += ` ${client.first_name}`);
    return output;
  };

  const navigate = useNavigate();
  const isMobile = useWindowWidth() <= 768;

  const ids: number[] = [];

  client &&
    client.user.custom_groups &&
    client.user.custom_groups.length > 0 &&
    client.user.custom_groups.map((group) => ids.push(group.id));

  // useEffect(() => {
  //   if (
  //     isSelecting &&
  //     client &&
  //     idGroup &&
  //     !isClientSelected(id) &&
  //     ids.includes(Number(idGroup))
  //   ) {
  //     selectForList(id, !isClientSelected(id));
  //   }
  // }, [idGroup]);
  const onSelect = () => setSelectedClient(client);
  const isSelectedAndNotMobile = selectedClient?.id === client.id && !isMobile;
  return (
    <li
      className={cn(st.item, isSelectedAndNotMobile && st.active)}
      onClick={() => {
        onClick?.();
        if (isMobile) {
          onClick?.();
          return (
            !isSelecting &&
            doRedirectWithSavePageUrl(`${client.id}`, { state: { path: window.location.pathname } })
          );
        }
        if (!isMobile) return onSelect();
      }}
      id={`${client.id}`}
    >
      <div
        className={st.item__color}
        style={{
          display: selectedClient?.id !== client.id || isMobile ? 'flex' : 'none',
          backgroundColor: `${client?.color_tag}`,
        }}
      />
      <SelectingIdsIconCheckbox className={st.item__body} name={'clients'} id={client.user.id} />
      <Avatar
        className={isSelectedAndNotMobile ? st.avatarOnActive : undefined}
        src={client?.photo}
      />

      <div className={cn(st.item__name)} onClick={onSelect}>
        {getClientName(client)}
      </div>
      <div className={st.item__right}>
        <div className={st.item__moderationIcon}>
          {!client?.is_registered && <ModerationCircle />}
        </div>
      </div>
    </li>
  );
};
